<script>
		import {fetch_data, send_data} from "../client.svelte.js";
		import {protoActions, protoDomains, protoSkills} from "../core.js";
		import {onMount} from "svelte";
		import Select from "../elements/Select.svelte";
		import Input from "../elements/Input.svelte";
		import Output from "../elements/Output.svelte";
		import Ability from "../elements/Ability.svelte";
		import Sidebar from "../elements/Sidebar.svelte";

		const categoryOptions = ['', 'Krieger', 'Zauberer', 'Spezialist']
		const environOptions = ['Stadt', 'Natur', 'Höhlen', 'Meer']
		const socialOptions = ['Wortführer', 'Wissender', 'Unbeteiligter']

		let fetching = $state(fetch_data('/archetypes'))
		let fellowships = $derived(
			user.fellowships.values()
				.filter(fshp => fshp.members.includes(user.ID))
				.toArray())
		let selectedFshp = $state((fellowships.length === 1) ? fellowships[0].ID : null)
		let selectedArchetype = $state(null)
		let filterCat = $state(null)


		function select_archetype(e) {
				selectedArchetype = this
		}

		function deselect_archetype(e) {
				selectedArchetype = null
		}

		async function create_hero(e) {
				console.log(`CREATE-HERO - Create a new hero in ${selectedFshp} based on archetype ${selectedArchetype.archetype}`, $state.snapshot(selectedArchetype))
				const response = await send_data('/hero/_', {fellowship: selectedFshp, archetype: selectedArchetype.archetype}, 'POST')
				console.log(response)
				const newHeroID = response['characters']?.[0]?.ID
				if (newHeroID) {
						await view.select_character(newHeroID)
						view.switch_layout('hero-descript')
				}
		}
</script>

<!-------------------------------- HTML -------------------------------------->

{#snippet filterFlyout()}
	<Select field='category' bind:value={filterCat} options={categoryOptions} />
{/snippet}

<section id='creation'>

	<header>
		<h1>Neuen Helden anlegen</h1>
	</header>

	<Sidebar flyout={filterFlyout} items={[
		{id: 'filter', icon: 'filter', label: "Filtern", flyout: "Vorlagen filtern", active: !!filterCat} ]}/>


	<article>
		{#await fetching}
			<p>Helden-Vorlagen werden geladen.</p>
		{:then allArchetypes}
			{@const archetypes = allArchetypes.filter(arch => !(filterCat) || arch.category === filterCat).sort((a,b) => a.archetype.localeCompare(b.archetype))}
			<div class="archetypes-box">
				{#if selectedArchetype}
					{@render archetype_card(selectedArchetype)}
					<div class="creation">
						<div class="fellowship">
							<p>Erstelle diesen neuen Helden für die Gemeinschaft:</p>
							<Select field='fellowship' options={fellowships} bind:value={selectedFshp} />
						</div>
						<button class="btn-primary btn-primary-circle icon-check" disabled={!selectedFshp} onclick={create_hero}>
							Held anlegen
						</button>
					</div>
				{:else}
					{#each archetypes as archetype}
						{@render archetype_card(archetype)}
					{/each}
				{/if}
			</div>
		{/await}
	</article>

	{#snippet archetype_card(archetype)}
		<div class="archetype-card" data-help="archetypes" onclick={select_archetype.bind(archetype)}>
			{#if archetype === selectedArchetype}
				<button class="close fa icon-square-xmark" onclick={deselect_archetype}></button>
			{/if}
			<figure id='picture' class="portrait">
				<img src="/static/archetypes/{archetype.archetype}.webp" alt="Token cannot be found" title={archetype.name}/>
			</figure>
			<Output field='archetype' value={archetype.archetype} style="font-size: large; font-weight: bold" disabled />
			<p>{archetype.description}</p>
			<Output field=category value={archetype.category} disabled />
			<Output field=primaries value={archetype.primaries} renderer={list_skills} />
			<Output field=emphasis value={archetype.emphasis} disabled />
			<Output field=secondaries value={archetype.secondaries} renderer={list_skills} />
			<Output field=provenance value={archetype.provenance} disabled />
			<Output field=domains value={archetype.domains} renderer={list_skills} />
		</div>
	{/snippet}

	{#snippet list_skills(items)}
		<div>
			{#each items as item}
				{@const ability = protoDomains[item] ?? protoSkills[item] ?? null}
				{#if ability}
					<Ability {ability}/>, &nbsp;
				{:else}
					<span>{item}, &nbsp;</span>
				{/if}
			{/each}
		</div>
	{/snippet}
</section>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	h1
		margin: 1.2em

	.archetypes-box
		display: flex
		flex-wrap: wrap
		padding: 32px
		gap: 16px
		justify-content: space-evenly

	// Hero Card
	.archetype-card
		position: relative
		width: 100%
		padding: 16px
		display: grid
		grid-template-columns: 140px 16ch auto
		gap: 8px
		background-color: colors.$grey-20

	figure
		display: inline-block
		margin: 16px

	figcaption
		text-align: center

	.portrait
		grid-area: 1 / 1 / span 4
		align-self: end
		justify-self: end
		margin: 0

	.portrait img
		width: 128px
		margin: 12px

	.creation
		display: flex
		gap: 3em

</style>